"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const EmailTemplateVersionDetail_1 = require("../EmailTemplateVersionDetail");
const react_2 = require("@osmosys/react");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const hooks_1 = require("../../../../hooks");
exports.EmailTemplateVersionModal = ({ template: { id: emailTemplateId } }) => {
    const { match, history } = use_react_router_1.default();
    const { data, loading, error } = hooks_1.useEmailTemplateVersion({
        emailTemplateId,
        emailTemplateVersionId: match.params.versionId,
        skip: !match.params.versionId || !emailTemplateId,
    });
    if (loading) {
        return react_1.default.createElement(reusables_1.Loading, null);
    }
    if (error) {
        // floatBottom dismissable
        return (react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "EmailTemplateVersion", action: "read", apolloError: error }));
    }
    if (!data) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "EmailTemplateVersionModal", isOpen: true, centered: true, size: "lg", toggle: () => {
            history.push(`/templates/${data.emailTemplateVersion.template.id}`);
        } },
        react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => {
                history.push(`/templates/${data.emailTemplateVersion.template.id}`);
            }, tag: "h3" },
            "Version ",
            data.emailTemplateVersion.version),
        react_1.default.createElement(reactstrap_1.ModalBody, { className: "px-4 py-3" },
            react_1.default.createElement(EmailTemplateVersionDetail_1.EmailTemplateVersionDetail, { hideVersion: true, data: data.emailTemplateVersion }))));
};
//# sourceMappingURL=EmailTemplateVersionModal.js.map